module.exports = __webpack_public_path__ + "img/score.30715cf5.png";